import { gql } from '@apollo/client'

export const csvCollectsGql = gql`
	query csvCollects($startDate: String, $stopDate: String) {
		csvCollects(startDate: $startDate, stopDate: $stopDate) {
			downloadURL
		}
	}
`
